let copySource = {
    document: {
        title:'ポイントを購入/プレゼントする'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.co.jp/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'ポイントを購入する',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=ja-JP&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=ja-JP&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'ポイントをプレゼント',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=ja-JP&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=ja-JP&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'ポイント倍増のチャンス',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=ja-JP&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=ja-JP&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.co.jp/default.mi'
        },
    },
    hero: {
        lang: 'landing-jp',
        headline: {
            lineOne: '思いつきもポイントで。\n今すぐ購入して、',
            lineTwo: 'いつでも気ままな旅を。',
        },
        subHeadline : 'ポイントがあれば、いつでも思いついたことを実現\nできます。見どころや楽しいアクティビティは\n尽きることがありません。楽しい寄り道やそのとき\nしたいことを思いのままに。今すぐ、ポイントを\n購入またはプレゼントしましょう。',
        alt:'ポイントにすべてを注ぎ、旅行で惜しみなく使いましょう。リストアップしていた憧れの旅行を予約するのもよし、もっと街に繰り出して夜を過ごすのもよし。今年はより多くを求めていける年。そんな、求めることすべてをかなえられるのがMarriott Bonvoy®ポイントです。',
    },
    promo: {
        hero: {
            promoLang: 'promo-jp',
            headline: "ポイントを増やして",
            subheadline: "気ままに旅を楽しみましょう",
            body:"3月31日までポイント購入でボーナスを獲得しましょう。 今すぐビーチバケーションに出かけたい？ 気に入った場所で滞在期間を延長したい？ ポイントがあれば、いつでも思いついたことを実現できます。",
        }
    },
    ctas:{
        buy:{
            imgAlt:'窓から街並みが見えるホテルの寝室内部。',
            header:'ポイントを購入する',
            copy:'宿泊日数の追加から、あっという間に完売するショーのVIP席購入\nまで、今すぐポイントを購入して万全の準備を整えましょう。',
            linkCopy:'ポイントを購入する',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=ja-JP&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=ja-JP&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'海を見下ろすプール付きのホテルのバルコニー。',
            header:'ポイントを贈る',
            copy:'ご友人やご家族にポイントをプレゼントして、好きな時に好きな\n場所へ気ままな旅を楽しんでもらいましょう。',
            linkCopy:'ポイントを贈る',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=ja-JP&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=ja-JP&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'ポイント倍増のチャンス',
            copy:'今なら最近の滞在で獲得されたポイント数の最大4倍を割引価格で購入できます。次回の旅を贅沢に楽しみましょう。',
            linkCopy:'ポイントをお得に購入',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=ja-JP&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=ja-JP&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: 'メンバーになりましょう',
            link: 'https://www.marriott.com/ja/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: 'メンバー向けの料金にアクセスしたり、無料宿泊に向けてポイントを獲得したりと、プログラムを活用しましょう。新規メンバーの方は、Marriott Bonvoプログラムにご登録後、30日後にポイントを購入することができます。'
        }
    },
    footer:{
        copyrightOne: '本Webサイトは、Points.com Inc.がMarriott International, Inc.に代わり、',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-JA-JP.html',
        copyrightTwo: 'Points.com Inc.の利用規約', 
        copyrightThree: 'に従ってMarriott Bonvoy Pointsを購入することを目的として運営しております。購入取引に関連してMarriott Bonvoy Pointsが付与および利用される場合は',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour: 'Marriott Bonvoyのプログラム規則',
        copyrightFive: 'と',
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix: 'プライバシーポリシー',
        copyrightSeven: 'が適用されます。',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/bonvoy_logo.png",
            grp1: "LUXURY",
            grp2: "PREMIUM",
            grp3: "SELECT",
            grp4: "MIDSCALE",
            grp5: "LONGER STAYS"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: '日本語',
        tracking:{
            doNotSell:{
                copy:'私の個人情報を販売しない',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'トラッキング設定',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'ご利用規約',
            href:'https://www.marriott.co.jp/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'プログラムのご利用規約',
            href:'https://www.marriott.co.jp/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'プライバシーセンター',
            href:'https://www.marriott.co.jp/privacy.mi'
        },
        accessibility:{
            copy:'デジタルアクセシビリティ',
            href:'https://www.marriott.co.jp/digital-accessibility.mi'
        },
        siteMap:{
            copy:'サイトマップ',
            href:'https://www.marriott.co.jp/sitemap.mi'
        },
        help:{
            copy:'ヘルプ',
            href:'https://www.marriott.co.jp/help.mi' 
        },
    }
    
}

export default copySource

